import { useMutation } from '@tanstack/react-query';
import { AxiosProgressEvent } from 'axios';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';

import { CNMCFile } from '../types';

import { cnmcQueryKeys } from './query-keys';

export type TUploadFileToCNMCParams = {
  cnmcId: string;
  file: File;
  signal?: AbortSignal;
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void;
};

export async function uploadFileToCNMC({
  cnmcId,
  file,
  signal,
  onUploadProgress,
}: TUploadFileToCNMCParams): Promise<CNMCFile> {
  const formData = new FormData();
  formData.append('file', file);

  return mediaManagerClient.post(`/api/v1/cnmcs/${cnmcId}/files`, formData, {
    signal,
    timeout: 0,
    onUploadProgress,
  });
}

type MutationFn = typeof uploadFileToCNMC;

type TUseUploadFileToCNMCParams = {
  config?: MutationConfig<MutationFn>;
};

export function useUploadFileToCNMC({ config = {} }: TUseUploadFileToCNMCParams = {}) {
  return useMutation({
    ...config,
    mutationFn: uploadFileToCNMC,
    onError(error) {
      console.error(error);
    },
    onSuccess(data, variables, context) {
      queryClient.invalidateQueries({ queryKey: cnmcQueryKeys.all });
      config.onSuccess?.(data, variables, context);
    },
  });
}
